export const classNames = classes =>
  classes.filter(cls => Boolean(cls)).join(' ')
